export default __webpack_public_path__ + "static/media/Rappi_logo.svg.7b2001f8.png";